// extracted by mini-css-extract-plugin
module.exports = {"List":"list_List__aZMzl","Marker":"list_Marker__7_TOX","ListItem":"list_ListItem__xtF0M"};